<div class="question-slider">
  <lib-question-hint 
    [hint]="'SLIDES.set_the_correct_answer_on_slider' | translate">
  </lib-question-hint>

  <lib-slider-widget 
    class="animate__animated"
    [unit]="data.unit"
    [max]="data.endValue"
    [min]="data.startValue"
    [stepsCount]="data.stepsCount"
    [questionHash]="questionHash"
    [ngClass]="data.animation"
    [style.animationDelay.ms]="data.animationDelay"
    [ngModel]="answer"
    (ngModelChange)="onChange($event)">
  </lib-slider-widget>
</div>
